// Incidents with a named owner (setter spec §05.2e, §05.19, §05.20). Schemas in api-incidents.ts. Shared by every module.
import * as I from './api-incidents.js';
import { IdParam, items, route, W, Ws } from './route-def.js';

const Inc = W({ incidentId: IdParam });

export const incidentRoutes = {
  listIncidents: route({
    method: 'GET', path: '/workspaces/:workspaceId/incidents', summary: 'Incidencias (mías o de todo el equipo)', tag: 'incidents',
    minRole: 'advisor', module: null, params: Ws, query: I.IncidentListQuerySchema, response: items(I.IncidentSchema),
  }),
  getIncident: route({
    method: 'GET', path: '/workspaces/:workspaceId/incidents/:incidentId', summary: 'Detalle de la incidencia con opciones de solución', tag: 'incidents',
    minRole: 'advisor', module: null, params: Inc, response: I.IncidentDetailSchema,
  }),
  createIncident: route({
    method: 'POST', path: '/workspaces/:workspaceId/incidents', summary: 'Registrar una incidencia para el responsable del proyecto', tag: 'incidents',
    minRole: 'advisor', module: null, params: Ws, body: I.CreateIncidentSchema, response: I.IncidentDetailSchema, status: 201,
  }),
  reportAdvisorUnavailable: route({
    method: 'POST', path: '/workspaces/:workspaceId/appointments/:appointmentId/unavailable', summary: '«No puedo atender esta cita»: incidencia al responsable del proyecto (no cambia la cita)', tag: 'incidents',
    minRole: 'advisor', module: null, params: W({ appointmentId: IdParam }), body: I.ReportAdvisorUnavailableSchema, response: I.IncidentDetailSchema, status: 201,
  }),
  acknowledgeIncident: route({
    method: 'POST', path: '/workspaces/:workspaceId/incidents/:incidentId/acknowledge', summary: 'Tomar la incidencia (el responsable confirma que la atiende)', tag: 'incidents',
    minRole: 'advisor', module: null, params: Inc, response: I.IncidentDetailSchema,
  }),
  resolveIncident: route({
    method: 'POST', path: '/workspaces/:workspaceId/incidents/:incidentId/resolve', summary: 'Resolver la incidencia con la solución elegida', tag: 'incidents',
    minRole: 'advisor', module: null, params: Inc, body: I.ResolveIncidentSchema, response: I.ResolveIncidentResponseSchema,
  }),
  escalateIncident: route({
    method: 'POST', path: '/workspaces/:workspaceId/incidents/:incidentId/escalate', summary: 'Escalar al siguiente responsable (suplente, luego administración)', tag: 'incidents',
    minRole: 'advisor', module: null, params: Inc, body: I.EscalateIncidentSchema, response: I.IncidentDetailSchema,
  }),
  reassignIncident: route({
    method: 'POST', path: '/workspaces/:workspaceId/incidents/:incidentId/reassign', summary: 'Asignar la incidencia a otra persona', tag: 'incidents',
    minRole: 'manager', module: null, params: Inc, body: I.ReassignIncidentSchema, response: I.IncidentDetailSchema,
  }),
  getIncidentConfig: route({
    method: 'GET', path: '/workspaces/:workspaceId/projects/:projectId/incident-settings', summary: 'Responsable de incidencias del proyecto', tag: 'projects',
    minRole: 'advisor', module: null, params: W({ projectId: IdParam }), response: I.IncidentConfigResponseSchema,
  }),
  putIncidentConfig: route({
    method: 'PUT', path: '/workspaces/:workspaceId/projects/:projectId/incident-settings', summary: 'Designar el responsable de incidencias del proyecto', tag: 'projects',
    minRole: 'admin', module: null, params: W({ projectId: IdParam }), body: I.IncidentConfigSchema, response: I.IncidentConfigResponseSchema,
  }),
};
